import styled from '@emotion/styled';

export const StyledHelpText = styled.div(({ theme }) => ({
    ...theme.mixins.useTextStyle('caption'),
    color: theme.colors.black,
    margin: `${theme.space[2]} 0`,
}));
